import { User } from '../models/user.model'
import * as UserActions from '../actions/user.action'

// 初始化数据值
const initialState: User = {
    accountId: null,
    disabled: null,
    gender: "",
    isOwner: null,
    tenantId: null,
    tenantName: "",
    userCode: "",
    userId: null,
    userMobile: "",
    userName: "",
    userRoles: [],
    status:""
}

export function reducer(state: User = initialState, action: UserActions.UserActions) {
  let res:User;
  switch (action.type) {
    case UserActions.SET_USER:
      res  = {
        ...action.payload,
        status:"login"
      }
      return res;

    case UserActions.REMOVE_USER:
       res = {
        accountId: null,
        disabled: null,
        gender: "",
        isOwner: null,
        tenantId: null,
        tenantName: "",
        userCode: "",
        userId: null,
        userMobile: "",
        userName: "",
        userRoles: [],
        status:""
    };
      return res;
    case UserActions.LOGIN:
      res  = {
        ...state,
        status:"login"
      }
      return res;
    case UserActions.LOGOUT:
      res  = {
        ...state,
        status:"logout"
      }
      return res;
    default:
      return state;
  }
}